export const LOAD_SENSORS = "LOAD_SENSORS";
export const LOAD_SENSORS_SUCCESS = "LOAD_SENSORS_SUCCESS";
export const LOAD_SENSORS_ERROR = "LOAD_SENSORS_ERROR";
